import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "tailwindcss/tailwind.css";
import useFetchData from "../../../../repo/get";
// Removi o hook usePostData para o teste do fetch
import ReactHowler from "react-howler";
import positiveSound from "../../../../assets/positive.mp3";
import negativeSound from "../../../../assets/negative.mp3";

const CardAtribuir = () => {
  const [data, setData] = useState([]);
  const [error, setError] = useState("");
  const [loadingMotorista, setLoadingMotorista] = useState(true);
  const [loadingRomaneios, setLoadingRomaneios] = useState(true);
  const [entregadorName, setEntregadorName] = useState("");
  const [globalFilter, setGlobalFilter] = useState("");
  const [codigoRomaneio, setCodigoRomaneio] = useState("");
  const [playSound, setPlaySound] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get("id");

  const { data: motoristaData, error: motoristaError } = useFetchData(`api/motoristas/findById/${id}`);
  const { data: romaneiosData, error: romaneiosError } = useFetchData(`api/devolucao/findByMotoristaAnNotColect/${id}`);

  // useEffect para motorista
  useEffect(() => {
    if (motoristaData) {
      setEntregadorName(motoristaData.nome);
      setLoadingMotorista(false);
    } else if (motoristaError) {
      setError("Erro ao carregar motorista.");
      setLoadingMotorista(false);
    }
  }, [motoristaData, motoristaError]);

  // useEffect para romaneios
  useEffect(() => {
    if (romaneiosData) {
      if (Array.isArray(romaneiosData)) {
        const formattedData = romaneiosData.map((item) => ({
          codigo: item.codigo.codigo,
          entregador: item.codigo.romaneio.entregador.nome,
          data: item.dataDevolvido.replace("T", " ").split(".")[0],
          status: item.codigo.type,
        }));
        setData(formattedData);
      } else {
        setData([]);
      }
      setLoadingRomaneios(false);
    } else if (romaneiosError) {
      setError("Erro ao carregar romaneios.");
      setLoadingRomaneios(false);
    }
  }, [romaneiosData, romaneiosError]);

  // Função para adicionar um romaneio usando fetch nativo
  const handleAdicionarRomaneio = async () => {
    if (!codigoRomaneio || !entregadorName) {
      setError("Por favor, preencha o código do romaneio.");
      setPlaySound(negativeSound);
      return;
    }

    setIsSubmitting(true);
    setError("");

    try {
      console.log("Enviando POST para:", `api/devolucao/save/${id}`);
      console.log("Dados enviados:", {
        codigo: codigoRomaneio,
        coletado: false,
        devolvido: false,
        finalizado: false,
        inbase: false,
      });
      const token = localStorage.getItem("accessToken");
      const response = await fetch(`https://api.lc-transportes.com/api/devolucao/save/${id}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          codigo: codigoRomaneio,
          coletado: false,
          devolvido: false,
          finalizado: false,
          inbase: false,
        }),
      });

      const result = await response.json();
      console.log("Resposta do POST (fetch):", result);

      if (result && result.message) {
        setError(result.message);
        setPlaySound(negativeSound);
      } else if (result && result.id) {
        const newRomaneio = {
          id: result.id,
          codigo: result.codigo.codigo,
          entregador: result.codigo.romaneio.entregador.nome,
          data: result.dataDevolvido.replace("T", " ").split(".")[0],
          status: result.codigo.type,
        };
        setData((prevData) => {
          const exists = prevData.some((item) => item.codigo === newRomaneio.codigo);
          return exists ? prevData : [newRomaneio, ...prevData];
        });
        setPlaySound(positiveSound);
      } else {
        setError("Código romaneio inválido.");
        setPlaySound(negativeSound);
      }
    } catch (err) {
      console.error("Erro no POST com fetch:", err);
      setError("Erro ao atualizar romaneio.");
      setPlaySound(negativeSound);
    } finally {
      setIsSubmitting(false);
      setCodigoRomaneio("");
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter" && !isSubmitting) {
      event.preventDefault();
      handleAdicionarRomaneio();
    }
  };

  if (loadingMotorista || loadingRomaneios) {
    return <p>Carregando...</p>;
  }

  const header = (
    <div className="flex flex-col md:flex-row justify-between items-center">
      <input
        type="text"
        value={globalFilter}
        onChange={(e) => setGlobalFilter(e.target.value)}
        placeholder="Filtrar resultados..."
        className="p-inputtext p-component"
      />
      <h4 className="text-2xl font-bold">{data.length} Coletas para devolucão</h4>
    </div>
  );

  return (
    <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white p-6">
      <div className="flex flex-col md:flex-row items-center justify-between">
        <div className="flex items-center justify-between mb-4">
          <h1 className="text-2xl font-bold p-component">{entregadorName || "Motorista não encontrado"}</h1>
        </div>
        <input
          type="text"
          placeholder="Adicionar romaneio ..."
          value={codigoRomaneio}
          onChange={(e) => setCodigoRomaneio(e.target.value)}
          onKeyDown={handleKeyDown}
          className="p-inputtext p-component mb-4"
        />
      </div>
      {error && <p className="text-red-500">{error}</p>}
      <DataTable
        value={data}
        paginator
        stripedRows
        rows={10}
        rowsPerPageOptions={[5, 10, 25, 50]}
        tableStyle={{ minWidth: "50rem" }}
        globalFilter={globalFilter}
        emptyMessage="Nenhum romaneio encontrado."
        header={header}
      >
        <Column
          field="codigo"
          header="Código"
          sortable
          style={{ minWidth: "12rem", fontSize: "13px" }}
          body={(rowData) => (
            <span data-label={rowData.codigo} style={{ userSelect: "text" }}>
              {rowData.codigo}
            </span>
          )}
        />
        <Column field="entregador" header="Entregador" sortable style={{ minWidth: "14rem" }} />
        <Column field="status" header="Tipo" sortable style={{ minWidth: "10rem" }} />
        <Column field="data" header="Data" sortable style={{ minWidth: "12rem" }} />
      </DataTable>
      {playSound && <ReactHowler src={playSound} playing={true} onEnd={() => setPlaySound(null)} />}
    </div>
  );
};

export default CardAtribuir;
